import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const FAST_EDITOR_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
